import React from 'react';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import Landing from './landing/landing';
import BottomNav from './components/BottomNav/BottomNav';
import ProductRangePage from './components/ProductRangePage/ProductRangePage';
import './App.css';

function App() {
  return (
    <BrowserRouter>
      <Routes>
        <Route path="/"              element={<Landing activeTab="home" />} />
        <Route path="/about"         element={<Landing activeTab="about" />} />
        <Route path="/shop"          element={<Landing activeTab="shop" />} />
        <Route path="/knowledge-hub" element={<Landing activeTab="knowledge" />} />
        <Route path="/contact"       element={<Landing activeTab="contact" />} />
        <Route path="/product/:slug" element={<Landing activeTab="product" />} />
        <Route path="/blog/:slug"    element={<Landing activeTab="blog" />} />
        <Route path="/admin"         element={<Landing activeTab="home" />} />
        <Route path="/my-orders"     element={<Landing activeTab="home" />} />
        <Route path="/profile"       element={<Landing activeTab="home" />} />
        <Route path="/pest-diseases" element={<Landing activeTab="pest-diseases" />} />
        <Route path="/our-products"  element={<Landing activeTab="our-products" />} />
        <Route path="/help-center"   element={<Landing activeTab="help-center" />} />
        <Route path="/ios-app"       element={<Landing activeTab="ios-app" />} />
        <Route path="/apk-app"       element={<Landing activeTab="apk-app" />} />
        <Route path="/android-app"   element={<Landing activeTab="apk-app" />} />
        <Route path="/checkout"      element={<Landing activeTab="home" />} />
        <Route path="/checkout/:id"  element={<Landing activeTab="home" />} />
        <Route path="*"              element={<Landing activeTab="404" />} />
      </Routes>

      {/* Mobile-only bottom dock — hidden on desktop via CSS */}
      <BottomNav />
    </BrowserRouter>
  );
}

export default App;
